export default {
    // 用户
    getAllArea: '/common/area', // 获取地区信息
    getUserInfo: '/user/info', // 获取用户信息或专家信息
    setUserInfo: '/user/info/change', // 修改用户头像及真实姓名
    getLoginStatus: '/user/islogin', // 获取用户是否登录
    getMessageCode: '/user/code', // 获取短信验证码
    getUserVerify: '/user/phone/verify', // 验证用户旧手机号
    setNewPhone: '/user/phone/change', // 修改手机号
    setUserRegister: '/user/signup', // 用户注册
    setUserLogin: '/user/signin', // 用户登录
    setUserNewPass: '/user/Retrieve', // 用户忘记密码
    setNewPass: '/user/change', // 用户修改密码
    getMessageList: '/front/notice/list', // 获取站内信列表
    getCollection: '/user/Collection/list', // 我的收藏,视频记录
    getExpenses: '/buy/list', // 消费记录
    getChat: '/user/Professor/Record', // 聊天记录
    delRecord: '/user/Collection/del', // 删除视频记录
    getfollowlist: '/user/news/followlist', // 获取关注列表
    getnewslist: '/user/news/newslist', // 获取消息列表
    getcommentlist: '/front/article/commentlist', // 获取评论列表
    getallcomment: '/user/news/comment', // 获取全部评论列表
    setUserFollow: '/user/news/follow', // 关注-取关
    setUserChat: '/user/news/news', // 发起私信
    getChatList: '/user/news/info', // 私信记录
    setReadAll: '/user/news/allread', // 私信全部标记已读

    // 首页
    getNavList: '/front/nav/list', // 获取导航列表
    getHotWords: '/front/Hotwords/list', // 获取热词列表
    getHeadline: '/front/Headlines/see', // 获取头条列表
    getBanner: '/front/chart/list', // 获取首页banner
    getAboutUs: '/front/class/Listmargin', // 获取首页关于我们
    getSideClass: '/front/class/listside', // 获取首页两侧分类
    getAdvList: '/front/Advertisement/list', // 获取首页广告
    getLinks: '/front/links/list', // 获取首页友情链接
    getMemberUnit: '/front/Membership/list', // 获取首页会员单位
    getClassAndArticle: '/front/article/Classarticle', // 获取首页分类文章列表
    getArticleList: '/front/article/list', // 根据分类id获取文章列表
    getHotArticle: '/front/article/Hotlist', // 获取热文推荐
    getArticleDetail: '/front/article/detail', // 获取文章详情
    getRelevant: '/front/article/Relevant', // 相关阅读
    getClassVideo: '/front/Article/classvideo', // 视频课程
    getVideo: '/front/article/video', // 视频课程
    getSearch: 'front/lookup/article', // 搜索
    getCrumbsDetail: '/front/crumbs/detail', // 获取面包屑
    getPartner: '/front/Membership/all', // 获取首页底部合作伙伴

    // 专家
    getExpertForum: '/user/Professor/forum', // 获取首页专家论坛
    getExpertList: '/user/Professor/list', // 获取专家列表
    getExpertArticle: '/front/Article/Listprofessor', // 获取专家文章列表
    getExpertDetail: '/user/Professor/Conversation', // 获取专家会话列表
    setExpertLaunch: '/user/Professor/Launch', // 发起专家会话
    getConverList: '/user/Professor/info', // 获取会话详情
    getReplyStatus: '/user/Professor/canreply', // 能否发起回复
    setConverReply: '/user/Professor/reply', // 会话继续提问

    // 内容
    setBuyCreate: '/buy/create', // 文章创建购买
    setBuySure: '/buy/success', // 文章或专家论坛确定购买
    setCollection: '/user/Collection/add', // 添加收藏
    cancelCollection: '/user/Collection/Cancel', // 取消收藏
    getNaListvById: '/front/class/down', // 根据id获取下级导航
    getCommentList: '/front/article/commentlist', // 获取文章评论列表
    setComment: '/front/article/comment', // 评论及追评文章
    labelList: '/user/news/labellist', // 标签列表
    // CFBB
    getmeetinginfo: '/front/meeting/contentlist', // 获取会议内容列表
    getexpertlist: '/front/meeting/expertlist', // 获取会议嘉宾
    cfbbDetail: '/special/detail', // 获取专题相关配置内容
    cfbbList: '/special/list', // 获取专题文章
    // 投稿
    addArticle: '/front/article/add', // 个人投稿
    addessay: '/front/article/add', // 个人投稿
    // 会员之家
    getMemberList: '/user/userlist', // 会员列表
    memberSearch: '/front/lookup/user', // 会员之家搜索
    // 专家智库
    getExpertType: '/User/Professor/Typelist', // 专家智库分类
    getProfessorList: '/user/Professor/list', // 智库专家列表
    professorSearch: '/front/lookup/expert', // 智库专家搜索
    stationSearch: '/front/lookup/article', // 站内搜索
    // 支付
    payCreate: '/pay/create',
    payConfirm: '/pay/confirm'
};
